import {
  FETCH_LOAD_TRASH_PROJECT_REQUEST,
  FETCH_LOAD_TRASH_PROJECT_SUCCESS,
  FETCH_LOAD_TRASH_PROJECT_FALUIRE,
  FETCH_SEARCH_TPROJECT
} from './loadAllTrashProjectsTypes'

const initialState = {
  loading: false,
  allTProject:null,
  allTrashProjectList: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LOAD_TRASH_PROJECT_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LOAD_TRASH_PROJECT_SUCCESS : return {
      ...state,
      allTrashProjectList: action.payload,
      allTProject:action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LOAD_TRASH_PROJECT_FALUIRE : return {
      ...state,
      loading: false,
      allTrashProjectList: null,
      allTProject:null,
      error: action.payload,
    }
    case FETCH_SEARCH_TPROJECT : return {
      ...state,
      allTrashProjectList:state?.allTProject?.filter((val) => (val?.name?.toLowerCase()?.includes(action?.payload?.toLowerCase())))
 
    }
    default : return state
  }
}

export default reducer
